import { Grid, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import theme from "../theme";

export default function FooterV2() {
  return (
    <div
      id="footer-wrapper"
      style={{
        backgroundColor: theme.palette.background.dark,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        style={{
          width: "100%",
          padding: "40px 0 80px 0",
          maxWidth: "1200px",
          margin: "0 20px",
        }}
      >
        <Grid item xs={12} md={3}>
          <img
            style={{ width: "100px" }}
            src={process.env.REACT_APP_LOGO_LIGHT}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography
            variant="body2"
            style={{ fontWeight: 600 }}
            sx={{ marginTop: { xs: "10px", md: "0" } }}
          >
            Unternehmen
          </Typography>
          <FooterMenuPoint
            href="https://www.inventure.de/ueber-uns"
            style={{ marginTop: "10px" }}
          >
            Über Uns
          </FooterMenuPoint>
          <FooterMenuPoint href="https://www.inventure.de/funktionsweise">
            Funktionsweise
          </FooterMenuPoint>
          <FooterMenuPoint href="https://www.inventure.de/presse">
            Presse
          </FooterMenuPoint>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography
            variant="body2"
            style={{ fontWeight: 600 }}
            sx={{ marginTop: { xs: "10px", md: "0" } }}
          >
            Venture Capital
          </Typography>
          <FooterMenuPoint
            href="https://www.inventure.de/academy"
            style={{ marginTop: "10px" }}
          >
            Academy
          </FooterMenuPoint>
          <FooterMenuPoint href="https://www.inventure.de/inventure-wiki">
            Wiki
          </FooterMenuPoint>
          <FooterMenuPoint href="https://www.inventure.de/faq">
            FAQs
          </FooterMenuPoint>
        </Grid>
        <Grid xs={12} md={3} />
        <Grid
          item
          xs={12}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
          style={{ display: "flex", marginTop: "60px" }}
        >
          <Typography variant="body2" style={{}}>
            ©inVenture Capital iVC GmbH
          </Typography>
          <FooterMenuPoint
            href="https://www.inventure.de/datenschutz"
            horizontal
          >
            Datenschutzerklärung
          </FooterMenuPoint>
          <FooterMenuPoint
            href="https://www.inventure.de/risikohinweis"
            horizontal
          >
            Risikohinweise
          </FooterMenuPoint>
          <FooterMenuPoint href="https://www.inventure.de/impressum" horizontal>
            Impressum
          </FooterMenuPoint>
        </Grid>
        <Grid item xs={12} style={{ display: "flex", marginTop: "60px" }}>
          <Typography variant="body2" style={{ fontSize: "12px" }}>
            Der Erwerb von tokenisierten Schuldverschreibungen ist mit
            erheblichen Risiken verbunden und kann zum vollständigen Verlust des
            eingesetzten Vermögens führen. Die Informationen auf dieser
            Plattform richten sich ausschließlich an Personen, die ihren
            Wohnsitz bzw. gewöhnlichen Aufenthalt in der Bundesrepublik
            Deutschland haben. Die Informationen stellen weder ein Angebot zum
            Kauf oder zur Zeichnung der tokenisierten Schuldverschreibungen noch
            eine Aufforderung zur Abgabe eines Angebots zum Erwerb der
            tokenisierten Schuldverschreibungen über die inVenture Plattform
            dar. Die Informationen haben ausschließlich werblichen Charakter.
            Insbesondere stellen diese Informationen keine Finanz- oder sonstige
            Anlageberatung dar. Die auf der Plattform enthaltenen Informationen
            können eine auf die individuellen Verhältnisse des Anlegers
            abgestellte anleger- und anlagegerechte Beratung nicht ersetzen. Die
            Emittentin weist deutlich darauf hin, dass zur Beurteilung der
            tokenisierten Schuldverschreibungen ausschließlich die Angaben im
            Basisinformationsblatt und den Anleihebedingungen der Emittentin
            maßgeblich sind, die auf der Internetseite veröffentlicht werden und
            dort kostenlos heruntergeladen werden kann.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

interface FooterMenuPointProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  href: string;
  horizontal?: boolean;
}

function FooterMenuPoint({
  style,
  children,
  href,
  horizontal,
}: FooterMenuPointProps) {
  return (
    <a
      target="blank"
      style={{ textDecoration: "none", color: "black" }}
      href={href}
    >
      <Typography
        style={{ ...style }}
        sx={{
          marginTop: { xs: "2px", md: horizontal ? "0px" : "2px" },
          marginLeft: { xs: "0", md: horizontal ? "20px" : "0px" },
        }}
        variant="body2"
      >
        {children}
      </Typography>
    </a>
  );
}
